import * as tslib_1 from "tslib";
import * as momentNs from 'moment';
var moment = momentNs; // the directly callable function
// can't simply import 'moment-timezone' because it attempts to load a JSON file,
// which the end-programmer might not have a loader setup for.
// the file we are importing is pre-built to have the lib + timezone data.
import 'moment-timezone/builds/moment-timezone-with-data';
import { NamedTimeZoneImpl, createPlugin } from '@fullcalendar/core';
var MomentNamedTimeZone = /** @class */ (function (_super) {
    tslib_1.__extends(MomentNamedTimeZone, _super);
    function MomentNamedTimeZone() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MomentNamedTimeZone.prototype.offsetForArray = function (a) {
        return moment.tz(a, this.timeZoneName).utcOffset();
    };
    MomentNamedTimeZone.prototype.timestampToArray = function (ms) {
        return moment.tz(ms, this.timeZoneName).toArray();
    };
    return MomentNamedTimeZone;
}(NamedTimeZoneImpl));
export default createPlugin({
    namedTimeZonedImpl: MomentNamedTimeZone
});
